function Home() {
    return (
        <div>
            <h2>Home Page</h2>
            <p>Welcome to the Slope Dashboard home page!</p>
        </div>
    );
}

export default Home;
